module.exports = __webpack_public_path__ + "img/eg-10-01.394adf57.jpg";